/** @jsx jsx */
import { jsx } from "theme-ui";
import PropTypes from "prop-types";
import { useEffect } from "react";
import OfflineWidget from "./OfflineWidget";
import OnlineWidget from "./OnlineWidget";
import RecurringWidget from "./RecurringWidget";

const DonationWidget = ({ ...props }) => {
  const isOffline = props.paymentSuccessUrl.includes("offline");
  useEffect(() => {
    // Fix for scroll down while focusing on form fields in mobile (IOS and Android)
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (props.enableRecurring || props.enableRecurringOffline) {
    return <RecurringWidget {...props} />;
  }
  if (props.enableOffline && isOffline) {
    return <OfflineWidget {...props} />;
  }
  return <OnlineWidget {...props} />;
};

DonationWidget.propTypes = {
  enableRecurring: PropTypes.bool,
  enableRecurringOffline: PropTypes.bool,
  enableOffline: PropTypes.bool,
  paymentSuccessUrl: PropTypes.string.isRequired,
};

DonationWidget.defaultProps = {
  enableRecurring: false,
  enableRecurringOffline: false,
  enableOffline: false,
};

export default DonationWidget;
